(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tags"] && !Shopify.designMode) return;
  try {
    
   function filterToggle() {
     let btns = document.querySelectorAll('.subCategoriesWrapper .filter-sidebar .slide-button');

     if(!btns) return;
     
     btns.forEach(btn => {
       btn.addEventListener('click', function(){
         this.classList.toggle('active');
         this.nextElementSibling.classList.toggle('show-filter');
       });
     });
   }

  document.addEventListener('DOMContentLoaded', function(){
    filterToggle();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["craftglory-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-craftglory-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section--header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      requestAnimationFrame(() => this.initHeroObserver());
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.onHeroScrollHandler) {
        window.removeEventListener('scroll', this.onHeroScrollHandler);
      }
      if (this.heroResizeObserver) {
        this.heroResizeObserver.disconnect();
      }
    }

    initHeroObserver() {
      const isTransparentEligible =
        document.body.classList.contains('template-index') ||
        document.body.classList.contains('has-transparent-header');
      if (!isTransparentEligible) return;

      const updateHeaderHeight = () => {
        if (this.header) {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
      };

      updateHeaderHeight();

      const hero = document.querySelector(
        '#MainContent .bnr-section, #MainContent .all-products-banner, #MainContent .slideshow, #MainContent slideshow-component, #MainContent .heritage-hero-banner, #MainContent #heritage-hero, #MainContent > .shopify-section:first-child, #MainContent > :first-child'
      );
      if (!hero) {
        requestAnimationFrame(() => this.initHeroObserver());
        return;
      }

      const updateHeaderTransparency = () => {
        const isMegaMenuOpen = !!this.header.querySelector('.header__inline-menu details[open]');
        const isDrawerOpen = !!this.header.querySelector('#Details-menu-drawer-container[open]');
        if (isMegaMenuOpen || isDrawerOpen) {
          this.header.classList.remove('header--transparent-hero');
          this.header.classList.add('header--solid');
          return;
        }

        const headerHeight = this.header.offsetHeight || 65;
        const heroRect = hero.getBoundingClientRect();

        if (heroRect.bottom > headerHeight) {
          this.header.classList.add('header--transparent-hero');
          this.header.classList.remove('header--solid');
        } else {
          this.header.classList.remove('header--transparent-hero');
          this.header.classList.add('header--solid');
        }
      };

      this.header.querySelectorAll('.header__inline-menu details').forEach((details) => {
        details.addEventListener('toggle', updateHeaderTransparency);
      });

      const drawer = this.header.querySelector('#Details-menu-drawer-container');
      if (drawer) {
        drawer.addEventListener('toggle', updateHeaderTransparency);
      }

      this.onHeroScrollHandler = updateHeaderTransparency;
      window.addEventListener('scroll', this.onHeroScrollHandler, { passive: true });
      window.addEventListener(
        'resize',
        () => {
          updateHeaderHeight();
          updateHeaderTransparency();
        },
        { passive: true }
      );

      hero.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', updateHeaderTransparency, { once: true });
        }
      });

      if (window.ResizeObserver) {
        this.heroResizeObserver = new ResizeObserver(updateHeaderTransparency);
        this.heroResizeObserver.observe(hero);
      }

      updateHeaderTransparency();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > (this.headerBounds.top || 0)) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
